import styled from 'styled-components';
import { GoChevronLeft } from 'react-icons/go';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0 40px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const Container = styled.div`
  width: 1200px;

  @media screen and (min-width: 961px) and (max-width: 1210px) {
    width: auto;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Title = styled.h2`
  font-weight: 700 !important;
  font-size: 36px !important;
  color: ${(props) => props.theme.colors.primaryDark2};
  margin-bottom: 20px;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin-bottom: 12px;
  }
`;

export const Subtitle = styled.h2`
  font-weight: 700;
  font-size: 24px;
  color: ${(props) => props.theme.colors.black};
  /* text-align:center; */
  margin: 40px 0 24px 0;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin-bottom: 12px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 288px - 80px);

  .row,
  .row-number {
    display: flex;
    justify-content: space-between;
  }

  .row-mob {
    display: none;
  }

  .row-desk {
    width: 48%;
    display: block;
  }

  .top {
    margin-top: 24px;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    justify-content: center;
    .row {
      display: flex;
      flex-direction: column;
    }

    .row-mob {
      display: block;
    }

    .row-desk {
      display: none;
    }

    .top {
      margin-top: 0;
    }
  }
`;

export const Progress = styled.div<{ percentage: number }>`
  min-width: 288px;
  height: 306px;
  display: flex;
  flex-direction: column;
  padding: 32px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.02);
  border-radius: 20px;
  margin-left: 80px;

  .progress-bar {
    width: 84px;
    height: 84px;
    margin: 0 auto;
    margin-bottom: 28px;
  }

  .name {
    color: ${(props) => props.theme.colors.gray};
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 12px;
    text-align: center;
  }

  .warning {
    color: ${(props) => props.theme.colors.black};
    font-size: 16px;
    font-weight: 400;
    text-align: ${(props) => (props.percentage ? 'center' : 'left')};
    line-height: 160%;
    max-width: calc(288px - 32px);
  }

  .complete {
    color: ${(props) => props.theme.colors.white};
    background: ${(props) => props.theme.colors.primary};
    border-radius: 50px;
    width: 84px;
    height: 84px;
    margin: 0 auto;
    padding: 30px 10px;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 28px;
  }

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    margin-left: 40px;
  }

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const Column = styled.div<{ size: number; width?: number }>`
  display: flex;
  flex-direction: column;
  width: ${(props) => `${props.size}%`};

  @media screen and (max-width: 960px) {
    width: ${(props) => (props.width ? `${props.width}%` : '100%')};
    margin-top: 24px;
  }
`;

export const Label = styled.h2`
  color: ${(props) => props.theme.colors.gray};
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 11px;
`;

export const ValidateNumber = styled.h2`
  color: ${(props) => props.theme.colors.primary};
  font-size: 16px;
  font-weight: bold;
  padding-top: 45px;
  text-align: center;
  cursor: pointer;

  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }

  @media screen and (max-width: 960px) {
    padding-top: 70px;

    .desktop {
      display: none;
    }

    .mobile {
      display: block;
    }
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-bottom: 20px;

  & > :first-child {
    flex-grow: 1;
    transform: translate(0, 25%);
  }

  & > :nth-child(2) {
    position: absolute;
    left: 25%;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.primaryDark2};
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  span {
    font-size: 18px;
  }

  &:focus {
    outline: none;
  }
`;

export const StyledChevronLeft = styled(GoChevronLeft)`
  font-size: 24px;
  margin-right: 10px;
`;
